var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:([!_vm.opennedWidget ? {visibility: 'hidden', right: '3000px'} : {visibility: 'visible'}]),attrs:{"id":"app_ask"}},[_c('WidgetButton',{style:({visibility: !_vm.getVisibleBtnOfDefaultLang ? 'visible' : 'hidden'}),nativeOn:{"click":function($event){return _vm.openWidget()}}}),_vm._v(" "),(_vm.opennedWidget)?_c('Widget'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5677e089","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 